import { createContext, useReducer } from 'react'
import { type SaveProviderProps, type SaveDataContextProps, type SaveDispatchContextProps } from 'src/types'

import { reducer } from './reducer'
import { newsave } from './defaults'

export const SaveDataContext = createContext<SaveDataContextProps>({ save: newsave })
SaveDataContext.displayName = 'SaveDataContext'

export const SaveDispatchContext = createContext<SaveDispatchContextProps>({ dispatchSave: () => null })
SaveDispatchContext.displayName = 'SaveDispatchContext'

export const SaveProvider = ({ children }: SaveProviderProps) => {
  const [save, dispatchSave] = useReducer(reducer, newsave)
  
  return (
    <SaveDataContext.Provider value={{ save }}>
      <SaveDispatchContext.Provider value={{ dispatchSave }}>
        {children}
      </SaveDispatchContext.Provider>
    </SaveDataContext.Provider>
  )
}
